import React from 'react';
import { useSelector } from "react-redux";
import styles from './PriceTrendChartWidget.less';
import PriceHistoryWidgetWithRentPrice
  from "../../../../components/PriceHistory/Widget/PriceHistoryWidgetWithRentPrice";
import { getRealEstateType } from "../../../../selectors/selectors";
import { PROPERTY_BOOK } from "../../../../tracking/trackingNaming";

const PriceTrendChartWidget = () => {
  const realEstateType = useSelector(getRealEstateType);
  return (
    <div className={styles.priceTrendChartWidget}>
      <PriceHistoryWidgetWithRentPrice
        address={'Deutschland'}
        title={'So entwickeln sich die Immobilienpreise in Deutschland'}
        realEstateType={realEstateType}
        trackingAction={PROPERTY_BOOK}
      />
    </div>
  )
}

export default PriceTrendChartWidget;
